module.exports = __webpack_public_path__ + "img/成功.2aa48005.png";